const MainPage = () => {
    if (!window.eS) return;

    const generalInfo = {};
    if (window.phone) generalInfo.user_phone = window.phone;
    if (window.email) generalInfo.user_email = window.email;

    window.eS('sendEvent', 'MainPage', {
        'GeneralInfo': {
            ...generalInfo
        }
    });
}

export default MainPage;